import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PriceRangeModel} from '../../../models/PriceRangeModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import * as toastr from 'toastr';
import {MatTableDataSource} from '@angular/material';

@Component({
  selector: 'app-price-range',
  templateUrl: './price-range.component.html',
  styleUrls: ['./price-range.component.scss']
})
export class PriceRangeComponent extends BaseGeneralComponent implements OnInit, OnChanges {

  priceRangeList: Array<PriceRangeModel>;
  dataSource = new MatTableDataSource();
  displayedColumns: Array<string>;
  priceRangeCount: number;
  checkboxLastRange: boolean;
  maxVolumeEnable: boolean;
  addPriceRangeDisable: boolean;
  lastElementRange: boolean;
  minVol: number;
  maxVol: number;
  price: number;

  @Input() inputList?: Array<PriceRangeModel> = [];
  @Input() readonly = false;
  @Input() resetRangePrice?: any;

  @Output() priceListOutput = new EventEmitter();

  constructor(private changeDetectorRefs: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.displayedColumns = ['PriceRangeElement', 'minVol', 'maxVol', 'priceVol'];
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('resetRangePrice' in changes) {
      this.priceRangeList = new Array<PriceRangeModel>();
      this.priceRangeCount = 0;
      this.minVol = 0;
      this.checkboxLastRange = false;
      this.maxVolumeEnable = true;
      this.addPriceRangeDisable = false;
      this.lastElementRange = false;
    }
    if (this.inputList.length > 1) {
      this.inputList.sort((a, b) => (a.volMin > b.volMin) ? 1 : -1);
      this.priceRangeList = this.inputList;
      this.dataSource.data = this.priceRangeList;
      this.priceRangeCount = this.inputList.length;
      this.lastElementRange = !this.readonly;
      this.checkboxLastRange = true;
    }
  }

  addPriceRange() {
    if (this.checkFields()) {
      const priceRangeElement = new PriceRangeModel(
        this.minVol,
        this.maxVol === -5 ? null : this.maxVol,
        this.price
      );
      this.minVol = this.maxVol + 1;
      this.maxVol = null;
      this.price = null;

      this.priceRangeList.push(priceRangeElement);
      this.refresh();
      this.priceRangeCount = this.priceRangeCount + 1;
      this.lastElementRange = this.priceRangeCount >= 6 || this.checkboxLastRange;
      this.priceListOutput.emit({ priceList: this.priceRangeList });
    }
  }

  removePriceRange() {
    const position = this.priceRangeCount - 1;
    if (position === -1) {
      this.minVol = 0;
      this.maxVol = null;
      this.price = null;
    } else {
      this.minVol = this.priceRangeList[position].volMin;
      this.maxVol = this.priceRangeList[position].volMax;
      this.price = this.priceRangeList[position].price;
    }
    this.priceRangeCount = this.priceRangeCount - 1;

    this.priceRangeList.pop();
    this.refresh();
  }

  editLastPriceRange() {
    this.lastElementRange = false;
    this.checkboxLastRange = true;
    const position = this.priceRangeCount - 1;
    this.minVol = this.priceRangeList[position].volMin;
    this.maxVol = this.priceRangeList[position].volMax;
    this.price = this.priceRangeList[position].price;
    this.priceRangeCount = this.priceRangeCount - 1;
    this.priceRangeList.pop();
    this.refresh();
    this.checkLastRangePrice(this.checkboxLastRange);

  }

  checkFields(): boolean {
    let returnValue = false;
    this.maxVol = this.priceRangeCount + 1 === 6 ? -5 : this.maxVol;
    if ((this.minVol !== null && this.maxVol !== null && this.price !== null)) {
      returnValue = true;
      if ((this.maxVol > this.minVol) || this.maxVol === -5) {
        this.maxVol = this.priceRangeCount + 1 === 6 ? null : this.maxVol;
        returnValue = true;
      } else {
        toastr.warning('Max Volume must be higher than Min Volume', 'Warning');
        returnValue = false;
      }
    } else {
      toastr.warning('Compile all range price fields', 'Warning');
      this.maxVol = this.priceRangeCount + 1 === 6 ? null : this.maxVol;
      returnValue = false;
    }

    return returnValue;
  }

  checkLastRangePrice(value: any) {
    if (this.price !== null) {
      this.checkboxLastRange = !value;
      this.maxVolumeEnable = !this.checkboxLastRange;
      if (this.maxVolumeEnable) {
        this.maxVol = null;
        this.addPriceRangeDisable = false;

      } else {
        this.maxVol = -5;
        this.addPriceRangeDisable = true;
        this.addPriceRange();
      }
    }
  }

  refresh() {
    this.dataSource.data = this.priceRangeList;
    this.changeDetectorRefs.detectChanges();
  }
}
